import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

const client = axios.create({ baseURL: API, withCredentials: true });

// Surface server-side detail as the error message
client.interceptors.response.use(
  (r) => r,
  (e) => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") e.message = d;
    return Promise.reject(e);
  }
);

export const adminApi = {
  // auth
  login: (password) => client.post("/auth/login", { password }),
  logout: () => client.post("/auth/logout"),
  me: () => client.get("/auth/me"),

  // goals
  listGoals: (project_slug, scope, scope_key) =>
    client.get("/goals", { params: { project_slug, scope, scope_key } }),
  createGoal: (body) => client.post("/goals", body),
  patchGoal: (id, body) => client.patch(`/goals/${id}`, body),
  deleteGoal: (id) => client.delete(`/goals/${id}`),

  // tasks
  listTasks: (project_slug, scope, scope_key) =>
    client.get("/tasks", { params: { project_slug, scope, scope_key } }),
  createTask: (body) => client.post("/tasks", body),
  patchTask: (id, body) => client.patch(`/tasks/${id}`, body),
  deleteTask: (id) => client.delete(`/tasks/${id}`),

  // notes
  getNote: (project_slug, date) => client.get(`/notes/${project_slug}/${date}`),
  putNote: (project_slug, date, text) =>
    client.put(`/notes/${project_slug}/${date}`, { text }),

  // recurring
  listRecurring: (project_slug) =>
    client.get("/recurring", { params: { project_slug } }),
  createRecurring: (body) => client.post("/recurring", body),
  deleteRecurring: (id) => client.delete(`/recurring/${id}`),
  toggleRecurring: (id, date, done) =>
    client.post(`/recurring/${id}/toggle`, { date, done }),

  // aggregates
  getDay: (project_slug, date) =>
    client.get("/day", { params: { project_slug, date } }),
  getHeatmap: (project_slug, year) =>
    client.get("/heatmap", { params: { project_slug, year } }),
  getToday: () => client.get("/today"),
  getStreak: () => client.get("/streak"),
  quickCapture: (project_slug, text) =>
    client.post("/quick-capture", { project_slug, text }),

  // AI
  aiRecap: (project_slug, period, anchor_date) =>
    client.post("/ai/recap", { project_slug, period, anchor_date }),
};

// project list (mirrors content.js but kept here so admin doesn't pull localized strings)
export const ADMIN_PROJECTS = [
  { slug: "levanta", name: "Levanta" },
  { slug: "evolvex", name: "Evolvex" },
  { slug: "four-colors", name: "Four Colors" },
  { slug: "the-eilati", name: "The Eilati" },
];

// helpers
export const todayStr = () => new Date().toISOString().slice(0, 10);

export const quarterOf = (monthIdx /* 1-12 */) => Math.ceil(monthIdx / 3);
export const monthsOfQuarter = (q) => [3 * q - 2, 3 * q - 1, 3 * q];

export const yearKey = (y) => String(y);
export const quarterKey = (y, q) => `${y}-Q${q}`;
export const monthKey = (y, m) => `${y}-${String(m).padStart(2, "0")}`;
export const dayKey = (y, m, d) =>
  `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

export const monthName = (m) =>
  ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][m - 1];

export const daysInMonth = (year, month /* 1-12 */) =>
  new Date(year, month, 0).getDate();
